import addAnswerValidationSelector from './poll_add_answer_validation_selector'
import creationToolContainerSelector from './poll_creation_tool_container_selector'
import deleteAnswerValidationSelector from './poll_delete_answer_validation_selector'
import editSettingsSelector from './poll_edit_settings_selector'
import saveSelector from './poll_save_selector'
import pollCancelSelector from './poll_cancel_selector'
import pollQuestionSelector from './poll_question_selector'
import pollSettingsSelector from './poll_settings_selector'
import pollUploadReferenceMediaSelector from './poll_upload_reference_media_selector'
import pollValidationSelector from './poll_validation_selector'
import pollTimerSelector from './poll_timer_selector'
import pollScreenshotSelector from './creation_tool_screenshot_selector'
import questionsChangedSelector from './poll_questions_changed_selector'

export default {
	addAnswerValidationSelector,
	creationToolContainerSelector,
	deleteAnswerValidationSelector,
	editSettingsSelector,
	saveSelector,
	pollCancelSelector,
	pollQuestionSelector,
	pollSettingsSelector,
	pollUploadReferenceMediaSelector,
	pollValidationSelector,
	pollTimerSelector,
	pollScreenshotSelector,
	questionsChangedSelector,
}
